import { Fragment, ReactElement } from 'react';
import ResearchCitizenshipAnscNotificationsShared from 'shell/components/shared/ansc-notifications/research-citizenship';
import { CitizenshipAnscNotificationsCancellationsCrumbs } from 'cancellations/constants/ansc-notifications.crumbs';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchCitizenshipAnscNotificationsPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchCitizenshipAnscNotificationsShared
        scope={IdAmbito.Cancellazioni}
        items={CitizenshipAnscNotificationsCancellationsCrumbs()}
      />
    </Fragment>
  );
};

ResearchCitizenshipAnscNotificationsPage.displayName =
  'Research Citizenship Notifications Page component';

export default ResearchCitizenshipAnscNotificationsPage;
